import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'
import { Booking, BookingItem } from '../interfaces/booking'
import { BookingObject } from '../interfaces/booking-object'
import { Resource, DurationRule } from '../interfaces/resource'
import { Setting } from '../interfaces/setting'
import { Calendar } from '../interfaces/calendar'
import * as io from 'socket.io-client'
import * as uuid from 'uuid/v1'
import * as moment from 'moment'

declare var encode: Function

@Injectable({
  providedIn: 'root'
})
export class DbService {

  debug = false
  version = 91
  socket
  //private url = 'https://db.bookmakeronline.se:3443'
  //private url = 'https://io.bokad.se'
  //private url = 'https://db.bokad.se:443'
  private url = 'https://db5.bokad.se'

  token = uuid()
  system = ''
  subSystem
  browserInfo
  workday = ''
  selectDate
  booking: Booking
  bookingObjects: BookingObject[] = []
  resources: Resource[] = []
  settings: Setting[] = []
  setting = { webtext1: '', webtext2: '', webtext3: '', return: '', weblogo: '', bottom: '', verify: '1', karens: '', webstop: 0, dagar: '30', infobox: '0', swishpay: 0, avismail: '', avissms: '', showEvents: 0, terms: '', enableQueue: 0, catering: '' }
  panel1Expanded = true
  bg = ''
  idLang = 0
  calendars: Calendar[] = []
  closedMessage = ''

  addTag = 0
    
  constructor() {

    this.booking = {
      id: uuid(),
      nr: 0,
      workday: '',
      contact: {
        id: '',
        fnamn: '',
        enamn: '',
        company: '',
        mobil: '',
        epost: '',
        system: ''

      },
      internalinfo: '',
      persons: 0,
      deleted: false,
      signature: 'WEB',
      locked: false,
      bookingItems: [],
      collapsedItems: [],
      tags: [],
      menuItems: [],
      unfinished: false,
      system: '',
      idGroupBooking: '',
      idGroupBookingTemplate: '',
      idGroupBookingStatus: '',
      groupBookingDay: 0,
      groupBookingPaid: false,
      idWaiter: '',
      offert: false,
      invoiceinfo: '',
      deliveryinfo: ''
    }

  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  //
  // Booking
  //
  ////////////////////////////////////////////////////////////////////////////////////////////

  addBookingItem(idResource, idBookingObject, start, duration, persons = 0): boolean {
    
    var ret = true
    
    this.booking.bookingItems.push({
      id: uuid(), 
      idResource: idResource,
      idBookingObject: idBookingObject,
      idEvent: '',
      start: start,
      duration: duration,
      status: 0,
      persons: 0,
      price: 0,
      vat: 0
    })

    this.collapseBookingItems(this.booking, this.bookingObjects)

    return ret
  }

  collapseBookingItems(b: Booking, bookingObjects: BookingObject[]) {
    b.collapsedItems = []
    var tmpItems = []
    b.bookingItems.forEach(bi => {
      var sortindex = 0
      bookingObjects.filter(bo => bo.id == bi.idBookingObject).forEach(bo => { sortindex = bo.sortindex })
      tmpItems.push({ id: bi.id, idBookingObject: bi.idBookingObject, idResource: bi.idResource, start: bi.start, duration: bi.duration, status: bi.status, persons: bi.persons, price: bi.price, vat: bi.vat, sortindex: sortindex, idEvent: bi.idEvent})
    })
    tmpItems.sort(this.sortfunc);
    tmpItems.forEach(bi => {
      var uniq = bi.idResource + "-" + bi.start + "-" + bi.duration;
      if (!b.collapsedItems.filter(c => c.uniq == uniq).length) b.collapsedItems.push({ id: uuid(), uniq: uniq, collapsed: '', bookingObjects: [], start: bi.start, duration: bi.duration, idResource: bi.idResource, persons: bi.persons, idEvent: bi.idEvent, status: 0, price: 0 });
      b.collapsedItems.filter(c => c.uniq == uniq)[0].bookingObjects.push(bi.idBookingObject);
      b.collapsedItems.filter(c => c.uniq == uniq)[0].price += bi.price
    });

    b.collapsedItems.forEach(c => {
      var a = [];
      c.bookingObjects.forEach(bo => {
        if (this.getBookingObject(bo, bookingObjects)) a.push(this.getBookingObject(bo, bookingObjects).number);
      });
      c.collapsed = this.getRanges(a).join(",");
    });
    return b;
  }

  getBookingObject(id, bookingObjects) {
    if ( bookingObjects.filter(bo => bo.id == id).length) {
      return bookingObjects.filter(bo => bo.id == id)[0]
    } else {
      return false
    }
  }

  sortfunc(a, b) {
    if (a.start < b.start) return -1;
    if (a.start > b.start) return 1;
    if (a.sortindex < b.sortindex) return -1;
    if (a.sortindex > b.sortindex) return 1;
    return 0;
  }

  getRanges(array) {
    var ranges = [], rstart, rend;
    for (var i = 0; i < array.length; i++) {
      rstart = array[i];
      rend = rstart;
      while (array[i + 1] - array[i] == 1) {
        rend = array[i + 1]; // increment the index if the numbers sequential
        i++;
      }
      ranges.push(rstart == rend ? rstart + '' : rstart + '-' + rend);
    }
    return ranges;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  //
  // SOCKET.IO
  //
  ////////////////////////////////////////////////////////////////////////////////////////////

  public sendMessage(room, message) {
    encode(message)
    if (this.debug) console.log("Sending message: ", message);
    this.socket.emit(room, message); 
  }

  public sendMessagePromise(room, message) {
    encode(message)
    //console.log(room, message.crc)
    let promise = new Promise((resolve, reject) => {
      this.socket.emit(room, message, (data) => {
        resolve(data)
      })
    })
    return promise
  }  

  public getConnected() {
    var r = false;
    if (this.socket) return this.socket.connected;
    return r;
  }

  connect() {
    //this.socket = io.connect(this.url)
  }

  disconnect() {
    this.socket.disconnect();
  }

  public getMessages() {

    let observable = new Observable(observer => {
      
      if (!this.socket) {
        //console.log('Connecting with token', this.token)
        this.socket = io.connect(this.url + '?token=' + this.token + '&version=' + this.version.toString(), { rejectUnauthorized: false, origins: "*" });
      }

      this.socket.on('message', (data) => {
        observer.next(data);
      });

      this.socket.on('login', (data) => {
        observer.next(data);
      });

      this.socket.on('db', (data) => {
        observer.next(data);
      });

      this.socket.on('connect', (data) =>{
        //if (this.debug) console.log("socket connect");
      });

      this.socket.on('reconnect', (data) =>{
        console.log('reconnect', data)
      });

      this.socket.on('connect_error', (data) =>{
        if (this.debug) console.log("connect failed", data);
      }); 

      /* Why?
      return () => {
        this.socket.disconnect();
      }*/

    })
    
    
    return observable;
  }

  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // Getters                                                                //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  getResource(id: string, resources: Resource[]): Resource {
    var r: Resource = { id: '', name: '', hasmap: false, ohid: 0, sortorder: 0, isrestaurant: false, unit: '', unitplural: '', confirmationtype: 0, defaultduration: 0, cleaningtime: 0, mapwidth: 0, mapheight: 0, interval: 0, api: 0, ppi: 0, csi: 0, acsi: 0, limit: 0, color: '', textcolor: '', zones: 0, web: false, webkarens: 0, autobookable: false, active: false, durations: [], idcalendar: '', remind: false, durationRules: [] }
    resources.filter(resource => resource.id == id).forEach(resource => { r = resource })
    if (this.system == 'st2lin' && r.name == 'Konferens') r.name = 'Kalas'
    return r
  }

  getSetting(name: string, defaultValue: string): string {
    var r = defaultValue
    this.settings.filter(setting => setting.name == name).forEach(setting => {
      r = setting.value
    })
    return r
  }

  
  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // Calendar functions                                                     //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  getCalRules(idCalendar: string, workday: string) {
    
    let calsToCheck = []

    // Main calendar
    let calendar = this.calendars.filter(c => c.id == idCalendar)[0]
    if (!calendar) return

    calsToCheck.unshift(calendar)

    // Get parents
    let idParent = calendar.idParent
    let safety = 0 // To avoid infinite loop
    
    while (idParent && safety++ < 10) {
        
      let parent = this.calendars.filter(c => c.id == idParent)[0]
      calsToCheck.unshift(parent)
      idParent = parent.idParent

    }

    return this.checkRules(calsToCheck, moment(workday))

  }

  checkRules(cals: Calendar[], date: moment.Moment) {
    
    let found = false
    let ret = { closed: false, bookableTimes: [], ruleName: '', shifts: false }

    cals.forEach(cal => {

      if (!found) cal.closedRules.filter(cr => cr.active).sort(this.sortOrderFunc).forEach(cr => {

        let condition1 = false
        let condition2 = false

        if (date.format('YYYY-MM-DD') >= moment(cr.fromDate).format('YYYY-MM-DD') && date.format('YYYY-MM-DD') <= moment(cr.toDate).format('YYYY-MM-DD')) condition1 = true
        var weekday = date.locale('sv').weekday()

        if (cr.mon && weekday == 0) condition2 = true
        if (cr.tue && weekday == 1) condition2 = true
        if (cr.wed && weekday == 2) condition2 = true
        if (cr.thu && weekday == 3) condition2 = true
        if (cr.fri && weekday == 4) condition2 = true
        if (cr.sat && weekday == 5) condition2 = true
        if (cr.sun && weekday == 6) condition2 = true      

        if (!found && condition1 && condition2) {
          found = true
          ret = { closed: true, bookableTimes: [], ruleName: cr.name, shifts: false }
        }

      })

      if (!found) cal.openRules.filter(cr => cr.active).sort(this.sortOrderFunc).forEach(cr => {

        let condition1 = false
        let condition2 = false

        if (date.format('YYYY-MM-DD') >= moment(cr.fromDate).format('YYYY-MM-DD') && date.format('YYYY-MM-DD') <= moment(cr.toDate).format('YYYY-MM-DD')) condition1 = true
        var weekday = date.locale('sv').weekday()

        if (cr.mon && weekday == 0) condition2 = true
        if (cr.tue && weekday == 1) condition2 = true
        if (cr.wed && weekday == 2) condition2 = true
        if (cr.thu && weekday == 3) condition2 = true
        if (cr.fri && weekday == 4) condition2 = true
        if (cr.sat && weekday == 5) condition2 = true
        if (cr.sun && weekday == 6) condition2 = true      

        if (!found && condition1 && condition2) {
          found = true
          ret = { closed: false, bookableTimes: cr.bookableTimes.filter(bt => bt.active), ruleName: cr.name, shifts: cr.shifts || false }
        }        

      })

    })

    return ret

  } 
  
  sortOrderFunc(a, b) {
    if (a.sortorder < b.sortorder) return -1
    if (a.sortorder > b.sortorder) return 1
    return 0
  }  


  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // MSGBUS                                                                 //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  private msgBusSubject = new Subject<any>();

  msgBusSendMessage(message: string, data?: any) {
    //if (this.debug) console.log("Sending local message:", message);
    this.msgBusSubject.next({ text: message, data: data });
  }

  msgBusclearMessage() {
    this.msgBusSubject.next();
  }

  msgBusGetMessage(): Observable<any> {
    return this.msgBusSubject.asObservable();
  }

  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // Gobal functions                                                        //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  isToday() {
    var now = new Date()
    var date = new Date(this.workday)
    return date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate()
  }
  
  minToTime(minutes: number, duration?: number) {
    if (minutes > 1439) minutes -= 1440;
    var time = "";
    time += this.numpad(Math.floor(minutes / 60)) + ":" + this.numpad(minutes - (Math.floor(minutes / 60) * 60));
    if (duration) time += " - " + Math.floor((minutes + duration) / 60) + ":" + this.numpad((minutes + duration) - (Math.floor((minutes + duration) / 60) * 60));
    return time;
  }

  numpad(d) {
    let p = '0';
    if (d > 9) p = '';
    return p + d;
  }

  sortSortOrder(a, b) { 
    if (a.sortorder < b.sortorder) return -1
    if (a.sortorder > b.sortorder) return 1
    return 0
  }

  getDuration(resource: Resource, persons: number, start: number, workday: string ): number {
    
    let dd = resource.defaultduration

    let done = false
    
    if (resource.durationRules) resource.durationRules.sortAndActive().forEach((dr: DurationRule) => {

      if (!done) {

        let valid = true

        if (persons && (persons < dr.fromPersons || persons > dr.toPersons)) valid = false

        if (start && (start < dr.fromMinute || start > dr.toMinute)) valid =  false

        if (workday) {
          let weekday = moment(workday).weekday()
          let dayrules = [dr.sun, dr.mon, dr.tue, dr.wed, dr.thu, dr.fri, dr.sat]
          if (!dayrules[weekday]) valid = false
        }

        if (valid) {
          dd = dr.duration
          done = true
        }

      }

    })    

    return dd

  }

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null
  }  

}
